import React from "react";
import ImageuploadContainer from "../containers/imageUpload/imageuploadContainer";
import { useQuery } from "../utils/useQuery";

export default function ImageUploadPage() {
	const queryParams = useQuery();
	const auth_token = queryParams.get("auth_token");
	const product_id = queryParams.get("product_id");
	const auction_id = queryParams.get("auction_id");
	const auction_name = queryParams.get("auction_name");
    const brand = queryParams.get("brand");
	const model = queryParams.get("model"); 
    //console.log(brand, model) 

	return (
		<ImageuploadContainer
			auth_token={auth_token}
			product_id={product_id}
			auction_id={auction_id}
			auction_name={auction_name}
            brand={brand}
            model={model}
		/>
	);
}
